import { render, staticRenderFns } from "./ModUserForm.vue?vue&type=template&id=299da4ca&"
import script from "./ModUserForm.vue?vue&type=script&lang=js&"
export * from "./ModUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports